import AuthService from '../../../services/auth/AuthService'
import ApiService from '../../../services/ApiService'
import * as jwt_decode from "jwt-decode";

export default {
  loginApp({ dispatch, commit }, { identification, password }) {
    return new Promise((resolve, reject) => {
      AuthService.loginApp(identification, password)
        .then(response => {
          const token = response.data.accessToken
          ApiService.setHeader('authorization', `${token}`);
          const decodedToken = jwt_decode(token);

          commit('saveIdentification', decodedToken.identification);
          commit('saveIdentificationType', decodedToken.identificationType);
          commit('savePatientName', response.data.name);
          let user = { identification: decodedToken.identification, identificationType: decodedToken.identificationType }

          commit('loginSuccess', { user, token })
          resolve(response)
        })
        .catch(error => {
          commit('loginFailure', error)
          reject(error)
        })

    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      ApiService.removeHeader()
      resolve()
    })
  },
  saveIdentification({ commit }, identification) {
    commit('saveIdentification', identification);
  }
}
